
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * Deprecated002 struct
 */
class Deprecated002 {
  /**
   * Copy struct (shallow copy)
   * @this {!Deprecated002}
   * @param {!Deprecated002} other Other struct
   * @returns {!Deprecated002} This struct
   */
  copy (other) {
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!Deprecated002}
   * @returns {!Deprecated002} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new Deprecated002Model(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new Deprecated002Model(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!Deprecated002}
   * @param {!Deprecated002} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof Deprecated002)) {
      throw new TypeError('Instance of Deprecated002 is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!Deprecated002}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return Deprecated002.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!Deprecated002} other Object value
   * @returns {!Deprecated002} Created struct
   */
  static fromObject (other) {
    return new Deprecated002().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!Deprecated002}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return Deprecated002.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!Deprecated002}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5153
  }
}

export { Deprecated002 };

/**
 * Fast Binary Encoding Deprecated002 field model
 */
class FieldModelDeprecated002 extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelDeprecated002}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelDeprecated002}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4
  }

  /**
   * Get the field extra size
   * @this {!FieldModelDeprecated002}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelDeprecated002}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelDeprecated002.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelDeprecated002}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5153
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelDeprecated002}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelDeprecated002}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelDeprecated002}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelDeprecated002}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelDeprecated002}
   * @param {!Deprecated002} fbeValue Default value, defaults is new Deprecated002()
   * @returns {!Deprecated002} Deprecated002 value
   */
  get (fbeValue = new Deprecated002()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelDeprecated002}
   * @param {!Deprecated002} fbeValue Deprecated002 value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelDeprecated002}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelDeprecated002}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelDeprecated002}
   * @param {!Deprecated002} fbeValue Deprecated002 value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelDeprecated002}
   * @param {Deprecated002} fbeValue Deprecated002 value
   */
  setFields (fbeValue) {
  }
}

export { FieldModelDeprecated002 };

/**
 * Fast Binary Encoding Deprecated002 model
 */
class Deprecated002Model extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelDeprecated002(this.buffer, 4)
  }

  /**
   * Get the Deprecated002 model
   * @this {!Deprecated002Model}
   * @returns {!FieldModelDeprecated002} model Deprecated002 model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!Deprecated002Model}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!Deprecated002Model}
   * @returns {!number} Model type
   */
  get fbeType () {
    return Deprecated002Model.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!Deprecated002Model}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelDeprecated002.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!Deprecated002Model}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!Deprecated002Model}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!Deprecated002Model}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!Deprecated002Model}
   * @param {!Deprecated002} value Deprecated002 value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!Deprecated002Model}
   * @param {!Deprecated002} value Deprecated002 value, defaults is new Deprecated002()
   * @return {!object} Deserialized Deprecated002 value and its size
   */
  deserialize (value = new Deprecated002()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new Deprecated002(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new Deprecated002(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!Deprecated002Model}
   * @param {!number} prev Previous Deprecated002 model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { Deprecated002Model };
